
export const tabsCurrentlyOpenedForReducerKey = "tabsCurrentlyOpenedFor"
export const tabsCurrentlyOpenedForInitialState = {
    detailsId:"",
    tabOpenedFor:"",
    tabOpened:"",
    data:{}
}